import { Box, Tooltip, Typography } from '@mui/material'
import { useTranslate } from 'ra-core'
import { createElement } from 'react'
import { useRecordContext } from 'react-admin'

import { VEHICLE_TYPES_ICONS } from '../config/vehicles'

const VehicleIconField = ({ color, source, ...props }) => {
  const translate = useTranslate()
  const record = useRecordContext(props)
  const type = record?.[source]
  const normalizedType = typeof type === 'string' ? type.toLowerCase() : null
  const tooltip = normalizedType ? `resources.vehicles.enums.type.values.${normalizedType}` : undefined
  const icon = VEHICLE_TYPES_ICONS[type]
  return icon ? (
    <Typography component="span" variant="body2" color={color}>
      <Tooltip title={translate(tooltip, { _: tooltip })}>
        <Box sx={{ marginTop: { xs: '4px', md: 0 } }}>{createElement(icon.type)}</Box>
      </Tooltip>
    </Typography>
  ) : null
}

VehicleIconField.defaultProps = {
  source: 'type',
}

export default VehicleIconField
